import React from 'react'

const B2CDashboard = () => {
    return (
        <div>B2CDashboard</div>
    )
}

export default B2CDashboard